import React from 'react'
import { observer } from 'mobx-react'
import { restaurantConfig, cartMobx } from 'restaurant'
import { checkoutMobx } from '@mobxStore'
import DiningNumberPickController from '@ctrls/diningNumberPickController'
import { Icon } from 'components'
import './index.scss'

interface IProps {
}

const CartPerson: React.FC<IProps> = ({ }) => {
  // 就餐人数
  const handleShowPeronPick = () => {
    DiningNumberPickController.showPicker()
  }

  return (
    (restaurantConfig.codeType !== 'brand' || cartMobx.info.eatType === 'dinein') && !checkoutMobx.dineinCanTogo ? (
      <div className='cart-person' onClick={handleShowPeronPick} data-cypid='cartPickPerson'>
        <div className='cart-person-left'>{i18n.t('queue.person')}</div>
        <div className='cart-person-right'>
          <div className='cart-person-info'>
            <Icon name='jiucanrenshu' size={18} />
            <span>{cartMobx.info.person + (cartMobx.info.kids || 0)}</span>
          </div>
          <Icon name='chevron-right' />
        </div>
      </div>
    ) : null
  )
}

export default observer(CartPerson)
